import React, { useEffect, useState } from 'react'
import { Avatar, Input } from 'antd-mobile'
import { SearchOutlined } from '@ant-design/icons'
import './css/TeamMembers.css'
import general from '../../../../general'
import Dialog from '../../../../lib/Dialog'
import { Button, Dialog as dialog } from 'antd-mobile'

export default function TeamMembers(props) {

  const [members,setMembers] = useState([])
  const [list,setList] = useState([])
  const [search,setSearch] = useState(false)

  const getMembers = (loading)=>{
    if (loading){
      Dialog.loading()
    }
    general.axios.post('/base/yunxin/teamListUsers',{tid:props.query.tid})
    .finally(()=>{
      if (loading){
        Dialog.close()
      }
    })
    .then(res=>{
      const {status,data} = res.data
      if(status.succeed){
        setMembers(data)
        setList(data)
      }else{
        Dialog.error(status.error_desc)
      }
    })
  }

  useEffect(()=>{
    if (props.active){
      getMembers(true)
      getTeamInfo()
    }
  },[props.active])

  const [is_appoint_intendant,setIs_appoint_intendant] = useState(false)
  const getTeamInfo = ()=>{
    general.axios.post('/base/yunxin/getClusterInfo',{tid:props.query.tid})
    .then(res=>{
      const {data,status} = res.data
      if (status.succeed){
        setIs_appoint_intendant(data.info.is_appoint_intendant)
      }else{
        Dialog.error(status.error_desc)
      }
    })
  }

  const enterPress = (value)=>{
    setSearch(value.length > 0)
    if (value.length > 0){
      let array = []
      for (let i =0;i<members.length;i++){
        const member = members[i]
        let filters = {title:member.title,list:[]}
        for (let j=0;j<member.list.length;j++){
          const obj = member.list[j]
          if (obj.nickname.search(value) != -1){
            filters.list.push(obj)
          }
        }
        array.push(filters)
      }
      const searchArr = array.filter(item=>{
        return item.list.length > 0
      })
      setList(searchArr)
    }else{
      setList(members)
    }
  }

  const mute = (item)=>{
    if (item.is_mute){
      return
    }
    dialog.show({
      content: item.is_mute ? `确定将 ${item.nickname} 解禁,是否继续` : `确定将"${item.nickname}"禁言,此操作不可撤回，是否继续`,
      closeOnAction:true,
      actions:[
        [
          {
            key: 'cancel',
            text: '取消',
          },
          {
            key: 'delete',
            text: '确定',
            onClick:()=>{
              general.axios.post('/base/yunxin/keepSilentMember',{
                tid:props.query.tid,
                be_username:item.username,
                mute: item.is_mute ? '0' : '1'
              }).then((res)=>{
                const {status} = res.data
                if (status.succeed){
                  Dialog.info(item.is_mute ? '解禁成功' : '禁言成功')
                  getMembers(false)
                }else{
                  Dialog.error(status.error_desc)
                }
              })
            }
          },
        ],
      ]
    })
  }

  const kickout = (item)=>{
    dialog.show({
      content: `确定将 ${item.nickname} 踢出，此操作不可撤回，是否继续`,
      closeOnAction:true,
      actions:[
        [
          {
            key: 'cancel',
            text: '取消',
          },
          {
            key: 'delete',
            text: '确定',
            onClick:()=>{
              general.axios.post('/base/yunxin/frontKickGroupSingle',{
                tid:props.query.tid,
                be_username:item.username
              }).then((res)=>{
                const {status} = res.data
                if (status.succeed){
                  Dialog.info('踢出成功')
                  getMembers(false)
                }else{
                  Dialog.error(status.error_desc)
                }
              })
            }
          },
        ],
      ]
    })
  }

  return (
    <div className='team-members-index'>
      <div className='team-members-container'>
        <div className="search">
          <div className="searchbar">
            <SearchOutlined className='search-icon'></SearchOutlined>
            <Input onChange={enterPress} placeholder='请输入用户昵称' clearable onEnterPress={enterPress}></Input>
          </div>
        </div>
        <div className="list">
          {list.map((item,idx)=>{
            return <div id={item.title === '群主' ? '#' : item.title} className='item' key={idx}>
              <div className="tag">{item.title}</div>
              {item.list.map(member=>{
                return <div className="member">
                  <Avatar src={member.icon} key={member.id} fallback={
                    <img src={'resources/user/avatar.png'}></img>
                  } style={{ 
                    '--size': '45px',
                    '--border-radius': '22px'
                  }}></Avatar>
                  <div className='name'>
                    <div>{member.nickname}</div>
                    {item.type == 'mmeber' && is_appoint_intendant && <div className="actions">
                      <div className='mute' onClick={()=>mute(member)}>{member.is_mute ? '已禁言' : '禁言'}</div>
                      <div className='kickout' onClick={()=>kickout(member)}>踢出</div>
                    </div>}
                  </div>
                </div>
              })}
            </div>
          })}
        </div>
        <div className="action">
          {list.map((item,idx)=>{
            return <div onClick={()=>{
              document.querySelector(`#${item.title}`).scrollIntoView({
                behavior:'smooth'
              })
            }}>
              {(()=>{
                if (item.title === '群主'){
                  return '#'
                }else if( item.title === '管理员'){
                  return ''
                }else{
                  return item.title
                }
              })()}
            </div>
          })}
        </div>
      </div>
    </div>
  )
}
